module.exports = __webpack_public_path__ + "img/browser.45643b3b.svg";